import React, {
    createContext,
    useState,
  } from 'react';
import { DataType_AllOperation } from '../../Components/Sections/AllCheckouts/types';
import { Transaction } from '../../Services/useGetMovements';
import { useOperations } from '../../Services/useOperations';

  class VoidContext implements VariablesContext {
    get collapsedFilsters(): never {
      throw new Error('Cannot consume context outside of provider');
    }
    get setCollapsedFilters(): never {
      throw new Error('Cannot consume context outside of provider');
    }
    get showForms(): never {
      throw new Error('Cannot consume context outside of provider');
    }
    get setShowForms(): never {
      throw new Error('Cannot consume context outside of provider');
    }
    get selectedRowId(): never {
      throw new Error('Cannot consume context outside of provider');
    }
    get setSelectedRowId(): never {
      throw new Error('Cannot consume context outside of provider');
    }
    get modalManager(): never {
      throw new Error('Cannot consume context outside of provider');
    }
    get dataTransactionsToForm(): never {
      throw new Error('Cannot consume context outside of provider');
    }
    get setDataTransactionsToForm(): never {
      throw new Error('Cannot consume context outside of provider');
    }
  }

  interface VariablesContext {
    collapsedFilsters: boolean,
    setCollapsedFilters: Function,
    showForms: ShowFormsProps 
    setShowForms: Function,
    selectedRowId: {id: string} | undefined,
    setSelectedRowId: Function,
    modalManager: Function,
    dataTransactionsToForm: Transaction | undefined,
    setDataTransactionsToForm: Function
  }

  interface propsWithChildren {
    children: React.ReactNode
  }

  export interface ShowFormsProps{
    deposit_extraction: boolean,
    transferer: boolean,
    buy_and_sell: boolean,
    transfers_between_cashs: boolean,
    transfer_to_suppliers: boolean,
    funds_movements: boolean,
    isEdition: boolean,    
    current_account_commission: boolean
    exchange_trasnfer: boolean
  }
  
  export const VariablesContext = createContext<VariablesContext>(new VoidContext());
  export const VariablesContextProvider= ({ children }: propsWithChildren): JSX.Element => {

    const { getOperation } = useOperations() 

    const [collapsedFilsters, setCollapsedFilters] = useState(false)
    const [selectedRowId, setSelectedRowId] = useState<{id: string}>()
    const [dataTransactionsToForm, setDataTransactionsToForm] = useState<Transaction>()
    const [showForms, setShowForms] = useState<ShowFormsProps>({
      deposit_extraction: false,
      transferer: false,
      buy_and_sell: false,
      transfers_between_cashs: false,
      transfer_to_suppliers: false,
      funds_movements: false,
      isEdition: false,    
      current_account_commission: false,
      exchange_trasnfer: false
    })


    const validateRelationships = async(transactionIdToFetch: string, operation_type_id: string):  Promise<Transaction | undefined> =>{
      const response = await getOperation(Number(transactionIdToFetch))
      if(response){
        if(
          ['1','2','3','4'].includes(operation_type_id) 
          && response.related_load_operation 
          && response.related_load_operation_id
        ){           
            if(response.related_load_operation.deleted){
              return response
            }else{
              let data =  await getOperation(Number(response.related_load_operation_id))
              if(data){
                return data
              }
            }            
        }
      }
      
      return response
    }

    const modalManager = async(record: DataType_AllOperation) =>{
      let isAccountValid: boolean = false //record.origin_account_customer_id !== '0' && record.destination_account_customer_id !== '0';
      let transactionIdToFetch
       let formStates: ShowFormsProps | undefined

      if(record && record.id && record.operation_type_id){
        switch(record.operation_type_id){
          case '1':
          case '2':
          case '3':
          case '4':
          case '7':  
          case '9': 
          case '16':          
          case '17': 
              if(record.related_operation_id && record.main_operation_id){
                transactionIdToFetch = record.main_operation_id          
              }else if(record.related_load_operation === 'false' && record.related_load_operation_id){//record.related_load_operation === 'true' si es false, es porque la operación asociada fue eliminada 
                transactionIdToFetch = record.related_load_operation_id
              }else{
                transactionIdToFetch = record.id            
              }
            break;  
          case '17':    
            if(record.related_load_operation === 'false' && record.related_load_operation_id){
              transactionIdToFetch = record.related_load_operation_id 
            }else{
              transactionIdToFetch = record.id
            }
            break;
          default:
            transactionIdToFetch = record.id
            break          
        }      
        
        if(transactionIdToFetch){
          const response = await validateRelationships(transactionIdToFetch, record.operation_type_id)//la selección en la tabla es sobre un depósito o extracción, pueden estar asociadas a una compra venta que esté asociada a una trasnferencia entre tercero. y la forma de chequearlo es pegandole al endpoint
          
          if(response){
            setDataTransactionsToForm(response)
            isAccountValid = record.origin_account_customer_id !== '0' && record.destination_account_customer_id !== '0'
            formStates = {
              deposit_extraction: [1, 2, 3, 4].includes(response.type.id),
              transfers_between_cashs: [5].includes(response.type.id) && isAccountValid,
              transferer: [6].includes(response.type.id) && isAccountValid,
              buy_and_sell: [7, 9].includes(response.type.id),
              transfer_to_suppliers: [10, 11].includes(response.type.id) && isAccountValid , 
              funds_movements: [14, 15].includes(response.type.id), 
              isEdition: true,
              current_account_commission: [16].includes(response.type.id),
              exchange_trasnfer:[17].includes(response.type.id) && isAccountValid
            };
          }
        }    
      }
      
       
     
      
      if(formStates){
        setShowForms(formStates);
      }                                                       
    }
 
    return (
      <VariablesContext.Provider value={{
        collapsedFilsters, 
        setCollapsedFilters,
        showForms, 
        setShowForms,
        selectedRowId,
        setSelectedRowId,
        modalManager,
        dataTransactionsToForm,
        setDataTransactionsToForm
      }}>{children}</VariablesContext.Provider>
    );
  };



  